import { VehicleStatusenum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('vehicle')

export class VehicleEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('varchar', {
        name: 'vehicle_type',
        nullable: false
    })
    vehicleType: string;

    @Column('int', {
        name: 'vehicle_capacity',
        nullable: false
    })
    vehicleCapacity: number;

    @Column('int', {
        name: 'mark_model_id',
        nullable: false
    })
    markModelId: number;

    @Column('int', {
        name: 'vehicle_category',
        nullable: false
    })
    vehicleCategory: number;

    @Column('varchar', {
        name: 'vehicle_name',
        nullable: false
    })
    vehicleName: string;

    @Column('varchar', {
        name: 'mark_model',
        nullable: true
    })
    markOrModel: string;

    @Column('varchar', {
        name: 'year_of_manufacture',
        nullable: true
    })
    yearofManufacture: Date | string;

    // @Column('varchar', {
    //     name: 'upload',
    //     nullable: true
    // })
    // upload: string;

    // @Column('varchar', {
    //     name: 'status',
    //     nullable: true
    // })
    // status: string;

    @Column('varchar', {
        name: 'registration_number',
        nullable: false
    })
    registrationNumber: string;

    // @Column('varchar', {
    //     name: 'engine_number',
    //     nullable: true
    // })
    // engineNumber: string;

    @Column('varchar', {
        name: 'chassis_number',
        nullable: true
    })
    chassisNumber: string;

    @Column('varchar', {
        name: 'fule_type',
        nullable: true
    })
    fuleType: string;

    @Column('varchar', {
        name: 'fuel_mesure_mentIn',
        nullable: true
    })
    fuelMesureMentIn: string;
 
    // @Column('varchar', {
    //     name: 'track_us_ageAs',
    //     nullable: true
    // })
    // trackUsageAs: string;

    @Column("varchar", { 
        nullable: true,
        default: true,
        name: "secondary_or_auxiliary_meter" 
    })
    secondaryOrAuxilaryMeter: string;

    @Column({
        type: 'enum',
        enum: VehicleStatusenum,
        name: 'status',
      })
      vehicleStatus: VehicleStatusenum;

    @Column('varchar', {
        name: 'insurance_number',
        nullable: true
    })
    insuranceNumber: string;

    // @Column('varchar', {
    //     name: 'insurance_start_date',
    //     nullable: true
    // })
    // insuranceStartDate: string;

    @Column('varchar', {
        name: 'insurance_expiry_date',
        nullable: true
    })
    insuranceExpiryDate: Date | string;

    @Column('varchar', {
        name: 'road_tex_no',
        nullable: true
    })
    roadTexNo: string;

    @Column('varchar', {
        name: 'road_tex_last_date',
        nullable: true
    })
    roadTexLastDate: Date | string;

    @Column('varchar', {
        name: 'national_permit_no',
        nullable: true
    })
    nationalPermitNo: string;

    @Column('varchar', {
        name: 'national_permit_last_date',
        nullable: true
    })
    nationalPermitLastDate: Date | string;

    @Column('varchar',{
        name: 'vehicle_servicing_date',
        nullable: true
    })
    vehicleServicingDate: Date | string;

    @Column('varchar',{
        name: 'vehicle_last_servicing_date',
        nullable: true
    })
    vehicleLastServicingDate: Date | string;

    @Column('varchar',{
        name: 'file_name',
        nullable: true
    })
    fileName: string;

    @Column('varchar',{
        name: 'file_path',
        nullable: true
    })
    filePath: string;

    @Column('int', {
        name: 'vendor_id',
        nullable: false
    })
    vendorId: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;


}